import { css } from 'styled-components';

// The subset files drop the Greek block, so Δ (U+0394) and the typographic
// ∆ (U+2206) otherwise they fall back to the system font mid-word.
// This points those code points to our font files ! only when one renders !
// Can extend unicode-range with additional vars if/when needed (line 22).
const DELTA_FACES = [
  ['Light', '300'],
  ['Regular', '350 400'],
  ['Medium', '500'],
]
  .flatMap(([name, weight]) =>
    ['normal', 'italic'].map(
      (style) => `
  @font-face {
    font-family: 'Seed Sans';
    src: url('/fonts/SeedSans-${name}${style === 'italic' ? 'Italic' : ''}.woff2')
      format('woff2');
    font-weight: ${weight};
    font-style: ${style};
    font-display: swap;
    unicode-range: U+0394, U+2206; 
  }
`,
    ),
  )
  .join('');

const FontFace = css`
  @font-face {
    font-family: 'Seed Sans Mono';
    src: url('/fonts/SeedSansMono-RegularItalic.woff2') format('woff2');
    font-style: italic;
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'Seed Sans Mono';
    src: url('/fonts/SeedSansMono-Regular-subset.woff2') format('woff2');
    font-style: normal;
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'Seed Sans';
    src: url('/fonts/SeedSans-Light-subset.woff2') format('woff2');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Seed Sans';
    src: url('/fonts/SeedSans-LightItalic-subset.woff2') format('woff2');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Seed Sans';
    src: url('/fonts/SeedSans-Regular-subset.woff2') format('woff2');
    font-weight: 350;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Seed Sans';
    src: url('/fonts/SeedSans-RegularItalic-subset.woff2') format('woff2');
    font-weight: 350;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Seed Sans';
    src: url('/fonts/SeedSans-Regular-subset.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Seed Sans';
    src: url('/fonts/SeedSans-RegularItalic-subset.woff2') format('woff2');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Seed Sans';
    src: url('/fonts/SeedSans-Medium-subset.woff2') format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Seed Sans';
    src: url('/fonts/SeedSans-MediumItalic-subset.woff2') format('woff2');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }

  ${DELTA_FACES}
`;

export { FontFace };
